import { useMutation } from '@tanstack/react-query';
import { reportService } from '../services/report';

export const useReport = (userId: string | number) => {
  /**
   * Mutation for fetching shipment report details
   */
  const shipmentReportMutation = useMutation({
    mutationFn: ({ startDate, endDate }: { startDate?: string; endDate?: string }) =>
      reportService.getShipmentReport(userId, startDate, endDate),
  });

  return {
    getShipmentReport: shipmentReportMutation.mutate,
    getShipmentReportAsync: shipmentReportMutation.mutateAsync,
    isFetchingReport: shipmentReportMutation.isPending,
    reportData: shipmentReportMutation.data,
    reportError: shipmentReportMutation.error,
  };
};
